import React from "react";
import Product_Management_Details from "./Details_Subcomponent/Product_Management_Details_Form";
import Product_Details_form from "./Details_Subcomponent/Product_Details_form";
import Self_life_form from "./Details_Subcomponent/Self_life_form";
import Description_About_Product_Form from "./Details_Subcomponent/Description_About_Product_Form";

function Product_Details({ setActiveTab, button }) {
  return (
    <div className="px-10">
      <Product_Management_Details />
      <Product_Details_form />
      <Self_life_form />
      <Description_About_Product_Form />
      <div className="w-full flex justify-end mt-5">
        <button
          onClick={() => setActiveTab("owner")}
          className=" bg-red-600 text-white px-9 rounded cursor-pointer outline-none hover:bg-red-700 py-1"
        >
          {!button ? " Next" : "Add Product"}
        </button>
      </div>
    </div>
  );
}

export default Product_Details;
